import {Checkbox, Grid, ListItem, ListItemIcon, ListItemText, withStyles,} from "@material-ui/core";
import {inject} from "mobx-react";
import {observer} from "mobx-react-lite";
import React from "react";

export const BOTOES_PRONTUARIO = {
  RECEITA: "Receita",
  DOCUMENTO: "Documento",
  GUIA_GTO: "Guia GTO",
  SP_SADT: "SP/SADT",
  GUIA_INTERNACAO: "Guia de Internação",
  ANAMNESE: "Anamnese",
  DADOS_ANTROPOMETRICOS: "Dados Antropométricos",
  ORCAMENTOS: "Orçamentos",
  AFERICOES_VITAIS: "Aferições Vitais",
  PROCEDIMENTOS: "Procedimentos",
  ENCAMINHAMENTOS: "Encaminhamentos",
  EVAH_IA: "Evah IA",
  EXAME: "Exame",
};

const botoesPrecisamPermissao = ["GUIA_INTERNACAO", "PROCEDIMENTOS", "EVAH_IA"]

const BotoesProntuario = observer(({ classes, prontuarioStore, hiddenProcedimentosButton }) => {
  const handleChangeCheckbox = (selecionado) => {

    const botoes = prontuarioStore.botoesProntuario.map((item) => {
      if (item.botao === selecionado.botao) {
        return { ...selecionado, visivel: !item.visivel }
      }
      return item
    })

    prontuarioStore.botoesProntuario = botoes
  };


  const possuiPermissao = (botao) => {
    const { canCreateGuiaInternacao, hasEvahIaDetalhado } = prontuarioStore;
    if (botao === "GUIA_INTERNACAO") {
      return canCreateGuiaInternacao;
    }
    if (botao === "EVAH_IA") {
      return hasEvahIaDetalhado;
    }
    if (botao === "PROCEDIMENTOS") {
      return !hiddenProcedimentosButton;
    }
  };

  return (
    <div className={classes.container}>
      <div className={classes.title}>
        Selecione os botões que devem aparecer no prontuario:
      </div>
      <Grid className={classes.gridContainer} container direction="column">
        {prontuarioStore?.botoesProntuario?.map((item, index) => {

          if (botoesPrecisamPermissao.includes(item.botao) && !possuiPermissao(item.botao)) {
            return null;
          }

          return (
            <div key={item.botao} className={classes.campoProntuario}>
              <Grid item>
                <ListItem
                  id={`prt-bpr-btn-chk-${index}`}
                  button
                  onClick={() => handleChangeCheckbox(item)}
                >
                  <ListItemIcon>
                    <Checkbox checked={item.visivel} color="primary" />
                  </ListItemIcon>
                  <ListItemText
                    id={item.botao}
                    primary={BOTOES_PRONTUARIO[item.botao]}
                    className={classes.listItemText}
                  />
                </ListItem>
              </Grid>
            </div>
          );
        })}
      </Grid>
    </div>
  );
});

const styles = {
  gridContainer: {
    display: "flex",
    flexDirection: "column",
    overflowY: "scroll",
    width: "100%",
    height: "100%",
    margin: 0,
    backgroundColor: "white",
    border: "1px solid rgba(0, 0, 0, 0.1)",
    boxShadow:
      "10px 10px 25px rgba(112, 124, 151, 0.05), 15px 15px 35px rgba(112, 124, 151, 0.05)",
    borderRadius: "10px",
  },
  title: {
    fontSize: "16px",
    padding: "5px",
  },
  campoProntuario: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "0 1rem",
    "&:hover": {
      backgroundColor: "rgba(0, 0, 0, 0.05)",
    },
  },
  listItemText: {
    fontSize: "14px",
    color: "#505050",
  },
  container: {
    height: "100%",
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
    width: "100%",
  },
};

const stores = ["prontuarioStore"];
const BotoesProntuarioWithStyles = withStyles(styles)(BotoesProntuario)
export default inject(stores)(BotoesProntuarioWithStyles);
